import { render, staticRenderFns } from "./clearPage.vue?vue&type=template&id=50483dc8&"
import script from "./clearPage.vue?vue&type=script&lang=js&"
export * from "./clearPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports